import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// custom components
import { CustomSpinner } from "_atoms";
// styling
import { Colors } from '_styles';
import styled from 'styled-components';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectJob, resetMenuContext, openPaxCheckInModal, setPaxLocation, setShowDeleteBookingModal, setShowFlightList, resetFlightContext } from '_redux/slices/utils/menu-context';
import {
    paxCheckOut, resetPaxCheckOutFlags, selectPaxCheckOutStatus, selectTimelineArrivalsBookingList, selectTimelineDeparturesBookingList, unplanTask, updateTask, updateTimeLineDepartureBookings,
    updateTimeLineArrivalsBookings, selectDuplicatedCombinedBookings, setDuplicatedCombinedBookings, selectDuplicatedCombinedRampBookings, setDuplicatedCombinedRampBookings, selectUnRejectPaxStatus,
    resetUnRejectPaxFlags, unRejectPax, selectUpdateTaskStatus, resetUpdateTaskFlags, setDuplicatedDepartureBookings, setDuplicatedArrivalsBookings, selectDuplicatedDeparturesBookings, selectDuplicatedArrivalsBookings,
    selectDeleteTaskStatus,
    resetDeleteFlags,
    setBookingLocation,
    selectPassengers
} from '_redux/slices/timeline/timeline-data';
import { selectEmployeeList, sendEmployeeNotification, selectSendNotificationStatus, resetSendingNotificationFlags, updateEmployee } from "_redux/slices/timeline/employees";
import { setShowBreakTaskModal, setBreakTaskEmployee, setSelectedBreakTask, setViewTask, setSelectedTaskToView, setSelectedTask, setEditModalType, setShowEditTaskModal } from "_redux/slices/timeline/selected-task";
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';
import { selectPostedBookingStatus, resetPostedBooking, selectPostedBooking, patchBooking, selectPatchBookingStatus } from '_redux/slices/prm-bookings/bookings';
import { setToast, setShowToast } from "_redux/slices/timeline/timeline-toast";

// utils
import { getDate, getEmployeeStatusForAppVersion } from "_utils/functions";

// icons
import { MdDeleteOutline } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { IoEyeOutline, IoNotificationsOutline } from "react-icons/io5";
import { BiUserCheck } from "react-icons/bi";
import { BiUserX } from "react-icons/bi";
import { MdQrCode2 } from "react-icons/md";
import { HiOutlineDuplicate } from "react-icons/hi";
import { FaCheck, FaCheckDouble } from "react-icons/fa6";
import { AiOutlineStop } from "react-icons/ai";
import { patchFlightSchedule } from '_redux/slices/flights/flight-information';



const StyledParagraph = styled.p`
    cursor: pointer;
    color: ${props => (props.color)};
    font-weight: 500;
    margin-left: 18px;
    margin-top: 12px;
    border-radius: 5px;
    width: 100%;
    font-size: 12px;
    display: flex;
    align-items: center;
`;

const MenuList = styled.div`
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0px 0px 5px 0px lightgray;
    max-width: 150px;
`;

const JobActionMenu = () => {
    // nav
    const history = useHistory();

    //#region redux
    const dispatch = useDispatch();

    const job = useSelector(selectJob);

    const allEmployees = useSelector(selectEmployeeList);
    const dbUser = useSelector(selectFirebaseInfo);                                       // logged in user
    const paxCheckOutStatus = useSelector(selectPaxCheckOutStatus);                       // status of passenger check out
    const arrivalsBooking = useSelector(selectTimelineArrivalsBookingList);         // arrival booking list
    const departuresBooking = useSelector(selectTimelineDeparturesBookingList);     // departures booking list
    const postBookingStatus = useSelector(selectPostedBookingStatus);               // post booking status
    const postedBooking = useSelector(selectPostedBooking);                         // posted booking object
    const patchBookingStatus = useSelector(selectPatchBookingStatus);                // patch booking status
    const unRejectPaxStatus = useSelector(selectUnRejectPaxStatus);                // UnReject passenger Status
    const updateTaskStatus = useSelector(selectUpdateTaskStatus);                // UnReject passenger Status

    const duplicatedCombinedBookings = useSelector(selectDuplicatedCombinedBookings);
    const duplicatedCombinedRampBookings = useSelector(selectDuplicatedCombinedRampBookings);
    const duplicatedDeparturesBookings = useSelector(selectDuplicatedDeparturesBookings);
    const duplicatedArrivalsBookings = useSelector(selectDuplicatedArrivalsBookings);
    const sendNotificationStatus = useSelector(selectSendNotificationStatus);
    const deleteTaskStatus = useSelector(selectDeleteTaskStatus);

    //#endregion

    //#region local states
    const [hover, setHover] = useState('none');
    const [canUnPlan, setCanUnPlan] = useState(true);                      // holds the value if the task can be unplanned
    const [canEdit, setCanEdit] = useState(true);                          // holds the value if the task can be edited
    const [canView, setCanView] = useState(true);                          // holds the value if the task can be viewed
    const [canCheckIn, setCanCheckIn] = useState(true);                    // holds the value if it is departure flight so the employee can check in
    const [canCheckOut, setCanCheckOut] = useState(false);                 // holds the value if it is departure flight so the employee can check in
    const [canAssign, setCanAssign] = useState(false);                     // holds the value if the task can be assigned to employee with QR scanner
    const [canDuplicate, setCanDuplicate] = useState(false);               // if the job has "WCHC" assistance can duplicate to assign to two employees
    const [duplicateCount, setDuplicateCount] = useState(0);
    const [canDeleteBooking, setCanDeleteBooking] = useState(true);        // holds the value if the booking can be deleted
    const [canUnReject, setCanUnReject] = useState(false);                   // holds the value if the pax is rejected to un reject it
    const [canStartTask, setCanStartTask] = useState(false);                 // holds the value if the task can be started
    const [canCompleteTask, setCanCompleteTask] = useState(false);          // holds the value if the task can be completed
    const [canStopTask, setCanStopTask] = useState(false);                  // holds the value if the task can be stopped
    const [canShowPaxList, setCanShowPaxList] = useState(false);            // holds the value to show passenger list
    const [canSendNotify, setCanSendNotify] = useState(false);              // holds the value if it can send employee notification or not
    const [shouldCloseMenu, setShouldCloseMenu] = useState(false);
    //#endregion

    //#region useEffect

    useLayoutEffect(() => {
        dispatch(resetSendingNotificationFlags())
        dispatch(resetDeleteFlags());
        setCanDuplicate(false);
    }, [])

    useEffect(() => {

        if (job) {
            // if job doesn't have assignedTime parameter (it's a booking in task list) or completed,active can't be unplanned
            if (!job?.assignedTime || job?.completed || job?.active) setCanUnPlan(false);
            else setCanUnPlan(true);

            // if job doesn't have assignedTime parameter (it's a booking in task list) can be assigned with QR code scanner
            if (!job?.assignedTime) setCanAssign(true);
            else setCanAssign(false);

            //if job has combinedBooking parameter (it's a combined booking in task list) or completed,active or cancelled can't be edited
            // if (job?.combinedBooking || job?.combinedRampBooking || job?.completed || job?.active || job?.cancelled || job?.duplicateVersion || job?._id?.includes("-part") || job?.assignedTime) setCanEdit(false);
            // else setCanEdit(true);

            if (job.completed || job.active || job.cancelled || job.duplicateVersion || job._id?.includes("-part") || (!job.assignedTime && job.passengers)) setCanEdit(false);
            else setCanEdit(true);

            // if job is not a break task it can be viewed
            if (job?.isBreakTask) setCanView(false);
            else setCanView(true);

            // if the job is not a combined departure or alternative pickup task or a duplicated booking the passenger can check in
            if (job?.flightConfirmationDetails?.origin !== dbUser.details.authority || job?.combinedBooking == true || job?.combinedRampBooking == true || job?.isALTPickUp == true || job?.duplicateVersion) setCanCheckIn(false);
            else setCanCheckIn(true);

            if (job?.paxPositionInfo?.activity == "Checked-in" || job?.originalBookingDoc?.paxPositionInfo?.activity == "Checked-in") setCanCheckOut(true);
            else setCanCheckOut(false);

            // if job is task in task list or isALTPickUp or isEstimatedBooking or combinedRampBooking and doesn't have duplicateVersion or combinedBooking and doesn't have duplicateVersion it can't be deleted
            if (job?.assignedTime || (job?.combinedRampBooking && !job?.duplicateVersion) || (job?.combinedBooking && !job?.duplicateVersion)) setCanDeleteBooking(false);
            else setCanDeleteBooking(true);

            if (!job?.assignedTime && (job?.originalBookingDoc?.rejectedPax == true || job?.rejectedPax == true)) setCanUnReject(true);
            else setCanUnReject(false);

            // if job has assignedTime (it's a task) and if it is not active, not completed it can be started
            if (job?.assignedTime && !job?.active && !job?.completed) setCanStartTask(true);
            else setCanStartTask(false);

            // if job has assignedTime (it's a task) and if it is active, not completed it can be completed
            if (job?.assignedTime && job?.active && !job?.completed && !job?.stopped) setCanCompleteTask(true);
            else setCanCompleteTask(false);

            // if job has assignedTime (it's a task) and if it is active, not completed it can be stopped
            if (job?.assignedTime && job?.active) setCanStopTask(true);
            else setCanStopTask(false);

            if (job?.assignedTime && job?.active && (job?.combinedRampBooking || job?.combinedBooking)) setCanShowPaxList(true);
            else setCanShowPaxList(false);

            if (job?.assignedTime && !job.completed) setCanSendNotify(true);
            else setCanSendNotify(false);

        }

    }, [job]);

    useEffect(() => {
        let tempBooking = null
        // if job has assignedTime (it's a task) else it is a bookings
        if (job?.assignedTime) {
            tempBooking = { ...job }

            // if it is a departure task and not a combined booking or estimated booking or alternative pick up task or already duplicated 
            if (tempBooking?.flightInformation?.departureAirport === dbUser?.details?.authority && !tempBooking?.isEstimatedBooking && !tempBooking?.isALTPickUp
                && !tempBooking?.combinedBooking && !tempBooking?._id?.includes("-part")
            ) {
                setCanDuplicate(true);
            } else if (tempBooking?.flightInformation?.arrivalAirport === dbUser?.details?.authority && !tempBooking?._id?.includes("-part") && !tempBooking?.combinedRampBooking) {
                setCanDuplicate(true);

            } else setCanDuplicate(false);
        } else {
            // if job object has originalBookingDoc  and flightBooking it's an arrival flight
            if (job?.originalBookingDoc && job?.flightBooking) {
                tempBooking = { ...job?.originalBookingDoc }
            } else {
                tempBooking = { ...job }
            }

            // if it is an original booking doc, allow duplication
            if (tempBooking.duplicateCount || !tempBooking.duplicateVersion) {
                setCanDuplicate(true);
            }
            else {
                setCanDuplicate(false);
            }

            if (tempBooking?.isEstimatedBooking || tempBooking?.isALTPickUp || (tempBooking?._id && tempBooking?._id?.includes("-part"))) {
                setCanDuplicate(false);
            }

            // arrival booking and already duplicated
            if (tempBooking?.flightConfirmationDetails?.destination === dbUser?.details?.authority && tempBooking?.duplicateCount) {
                setCanDuplicate(false);
            }
        }

    }, [job])


    useEffect(() => {
        if (!duplicatedCombinedBookings) { dispatch(setDuplicatedCombinedBookings([])) };
    }, [duplicatedCombinedBookings]);


    useEffect(() => {
        if (!duplicatedCombinedRampBookings) { dispatch(setDuplicatedCombinedRampBookings([])) };
    }, [duplicatedCombinedRampBookings]);

    // reset on check out passenger status succeeded or failed
    useEffect(() => {
        if (paxCheckOutStatus == "succeeded" || paxCheckOutStatus == "failed") {
            dispatch(resetPaxCheckOutFlags());
            handleCancel();
        }
    }, [paxCheckOutStatus]);

    useEffect(() => {
        if (unRejectPaxStatus == "succeeded") {
            dispatch(resetUnRejectPaxFlags());
            handleCancel();
        }
    }, [unRejectPaxStatus]);

    useEffect(() => {
        if (sendNotificationStatus === "succeeded") {
            dispatch(resetSendingNotificationFlags())
            handleCancel()
        }

    }, [sendNotificationStatus])


    useEffect(() => {
        if (patchBookingStatus == "succeeded") {
            let tempPostedBooking = {
                doc: {
                    ...postedBooking,
                    _id: postedBooking?.id
                },
                value: 1,
                key: ["ALL",
                    postedBooking?.flightConfirmationDetails?.destination === dbUser.details.authority ?
                        postedBooking?.flightConfirmationDetails?.destination
                        : postedBooking?.flightConfirmationDetails?.origin,
                    postedBooking?.flightConfirmationDetails?.destination === dbUser.details.authority ?
                        postedBooking?.flightConfirmationDetails?.arrivalTime
                        : postedBooking?.flightConfirmationDetails?.departureTime
                ]
            };

            if (tempPostedBooking) {
                // check if it is an arrival or departure update time line bookings
                if (tempPostedBooking?.doc?.flightConfirmationDetails?.origin === dbUser.details.authority) {
                    let tempDepartures = [...departuresBooking];
                    tempDepartures = tempDepartures.filter(item => item?.doc?._id !== tempPostedBooking?.doc._id);
                    // update time line departure booking list
                    dispatch(updateTimeLineDepartureBookings([...tempDepartures, tempPostedBooking]));
                } else if (tempPostedBooking?.doc?.flightConfirmationDetails?.destination === dbUser.details.authority) {
                    // update time line arrivals booking list
                    let tempArrivals = [...arrivalsBooking];

                    tempArrivals = tempArrivals.map((item) => {
                        if (item?.doc?._id == tempPostedBooking?.doc._id) return { ...tempPostedBooking }
                        return item;
                    })
                    dispatch(updateTimeLineArrivalsBookings([...tempArrivals]));
                };
            };
            let tempBooking = null;
            if (job?.assignedTime) {
                if (job?.flightBooking) {
                    const wantedBooking = arrivalsBooking.find(item => item?.doc?._id === job?.originalBookingId);
                    if (wantedBooking) tempBooking = { ...wantedBooking?.doc }
                } else {
                    const wantedId = job?._id.split("_IATA_")[0]
                    const wantedBooking = departuresBooking.find(item => item?.doc?._id === wantedId);
                    if (wantedBooking) tempBooking = { ...wantedBooking?.doc }

                }
            } else {
                if (job?.originalBookingDoc) tempBooking = { ...job?.originalBookingDoc };
                else tempBooking = { ...job };
            }
            if (tempBooking) {
                // check if it is an arrival or departure update time line bookings
                if (tempBooking?.flightConfirmationDetails?.origin === dbUser.details.authority) {
                    let tempDuplicatedDepartures = Array.isFullArray(duplicatedDeparturesBookings)
                        ? duplicatedDeparturesBookings?.filter((duplicate) => getDate(duplicate?.doc?.flightConfirmationDetails?.departureTime) == getDate(new Date()))
                        : [];
                    let tempDuplicatedObj = {
                        ...tempBooking,
                        _id: tempBooking?._id + "-part" + duplicateCount,
                        status: "user-confirmed",                                       // set to user confirmed status
                        name: tempBooking?.name + " " + "PART-" + duplicateCount,    // set name to include part number
                        duplicateVersion: duplicateCount
                    }
                    if (tempDuplicatedObj?.duplicateCount) delete tempDuplicatedObj?.duplicateCount
                    if (tempDuplicatedObj?.paxPositionInfo) delete tempDuplicatedObj?.paxPositionInfo;
                    // update time line departure booking list
                    dispatch(setDuplicatedDepartureBookings([
                        ...tempDuplicatedDepartures,
                        {
                            doc: {
                                ...tempDuplicatedObj
                            }
                        }
                    ]));
                } else if (tempBooking?.flightConfirmationDetails?.destination === dbUser.details.authority) {
                    let tempDuplicatedArrivals = Array.isFullArray(duplicatedArrivalsBookings)
                        ? duplicatedArrivalsBookings?.filter((duplicate) => getDate(duplicate?.doc?.flightConfirmationDetails?.arrivalTime) == getDate(new Date()))
                        : [];
                    let tempDuplicatedObj = {
                        ...tempBooking,
                        _id: tempBooking?._id + "-part" + duplicateCount,
                        status: "user-confirmed",                                       // set to user confirmed status
                        name: tempBooking?.name + " " + "PART-" + duplicateCount,    // set name to include part number
                        duplicateVersion: duplicateCount
                    }
                    if (tempDuplicatedObj?.duplicateCount) delete tempDuplicatedObj?.duplicateCount

                    // update time line departure booking list
                    dispatch(setDuplicatedArrivalsBookings([
                        ...tempDuplicatedArrivals,
                        {
                            doc: {
                                ...tempDuplicatedObj,
                            }
                        }
                    ]));
                };
            };
            dispatch(resetPostedBooking());
            handleCancel();
        }

    }, [postedBooking, patchBookingStatus]);

    useEffect(() => {
        if (updateTaskStatus == "succeeded") {
            //update flight schedule with start time
            const payload = {
                id: `${job?.flightInformation?.flightNumber}_${job?.flightInformation?.departureAirport}_${job?.flightInformation?.arrivalAirport}_${job.flightInformation?.departureDate}`,
                body: {
                    startTime: new Date()
                }
            }
            // dispatch(patchFlightSchedule(payload))
            dispatch(resetUpdateTaskFlags());
            handleCancel();
        };

    }, [updateTaskStatus]);

    useEffect(() => {
        if (deleteTaskStatus == "succeeded") {
            dispatch(resetDeleteFlags());
            handleCancel();
        };

    }, [deleteTaskStatus]);
    useEffect(() => {
        // Add event listener when the component mounts
        document.addEventListener('click', heardClick);

        // Cleanup the event listener when the component unmounts
        return () => {
            document.removeEventListener('click', heardClick);
        };
    }, []);

    // This useEffect tracks loading status change
    useEffect(() => {
        const isLoading = updateTaskStatus === "loading" || deleteTaskStatus === "loading" || sendNotificationStatus === "loading" || unRejectPaxStatus === "loading" || paxCheckOutStatus === "loading" || postBookingStatus === "loading" || patchBookingStatus === "loading";

        if (shouldCloseMenu && !isLoading) {
            handleCancel();            //close the menu after complete loading
            setShouldCloseMenu(false); // Reset the flag
        }
    }, [
        shouldCloseMenu,
        updateTaskStatus,
        deleteTaskStatus,
        sendNotificationStatus,
        unRejectPaxStatus,
        paxCheckOutStatus,
        postBookingStatus,
        patchBookingStatus,
    ]);

    //#endregion

    //#region functions


    const heardClick = () => {
        console.log('Mouse clicked on the screen!');
        if (hover === 'none') {
            setShouldCloseMenu(true); // Defer cancel until loading ends
        }
    };
    const getAssignedEmployee = (agentId) => {
        return allEmployees?.find((employee) => {
            return employee?.employeeId === agentId
                || employee?.uid === agentId
                || employee?.userId === agentId
                || employee?._id === agentId;
        });
    };

    const handleAgentStatus = (status, agentId) => {
        const assignedEmployee = getAssignedEmployee(agentId);
        const appVersionNumber = assignedEmployee?.appVersionNumber ?? job?.appVersionNumber;
        const versionedStatus = getEmployeeStatusForAppVersion(status, appVersionNumber);

        if (!versionedStatus) return;

        const payload = {
            userId: agentId,
            body: {
                status: versionedStatus
            }
        }
        dispatch(updateEmployee(payload))
    }


    // unplan task in employee list
    const handleUnplanTask = () => {
        // unplan task
        // toast message 
        dispatch(setToast({
            message: "Task unplanned successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));

        // if job has isALTPickUp means it's alternative pick up task and should update task by remove employeeId and assignedTime from the job object
        if (job && job?._id != undefined && job?.isALTPickUp == true) {
            let tempJob = {
                id: job._id,
                assignedTime: null,
                employeeId: null,
            }

            dispatch(updateTask(tempJob));
            handleCancel();

        } else if (job && job['_id'] != undefined) {
            // remove the job from task list
            // const bookingIds = getBookingIdsFromTask(job)
            const params = {
                taskId: job?._id,
                iata: dbUser.details.authority
                // bookingIds
            }
            dispatch(unplanTask(params));

        }

        handleAgentStatus("online", job.uid ?? job.employeeId)
    };


    // edit task
    const handleEditTask = () => {
        // check if selected job to edit is a break task or not
        if (job?.isBreakTask) {
            // get the selected employee
            let tempEmployee = allEmployees?.find((employee) => employee?.employeeId == job?.employeeId)
            // check if tempEmployee is not null and not empty
            if (!Object.isObjectEmpty(tempEmployee)) {
                // select the break task employee
                dispatch(setBreakTaskEmployee(tempEmployee))
                // open break task modal
                dispatch(setShowBreakTaskModal(true))
                // set the selected break task
                dispatch(setSelectedBreakTask(job))
            }
        } else {
            const modalType = job.assignedTime ? "TASK" : "BOOKING"
            dispatch(setEditModalType(modalType))
            dispatch(setShowEditTaskModal(true))
        }
        handleCancel();
    }
    const handleCancel = () => {
        dispatch(resetMenuContext());
        dispatch(resetFlightContext());
    };

    const handleViewTask = () => {
        dispatch(setViewTask(true));
        dispatch(setSelectedTaskToView(job));
        handleCancel();
    };

    // open passenger check in modal
    const handleCheckIn = (e) => {

        if (e.target.innerText == 'Set Passeneger Location') {
            dispatch(setPaxLocation(true))
        }
        dispatch(openPaxCheckInModal(true));

        handleCancel();
    };

    // check out passenger
    const handleCheckOut = () => {
        // if job has originalBookingId then choose the originalBookingId else _id
        let bookingId = job?.originalBookingId ? job?.originalBookingId : job?._id;
        dispatch(paxCheckOut(bookingId));
        handleCancel();
    };

    const handleUnRejectPax = () => {
        // if job has originalBookingId then choose the originalBookingId else _id
        let bookingId = job?.originalBookingId ? job?.originalBookingId : job?._id;
        if (bookingId) {
            dispatch(unRejectPax({
                iata: dbUser.details.authority,
                body: {
                    bookingsIDS: [bookingId]
                }
            }));
        };
    }
    const handleScannerClick = () => {
        dispatch(setSelectedTask(job));
        history.push('employee-scan')
        handleCancel();
    };
    const handleShowDeleteBookingModal = () => {
        dispatch(setShowDeleteBookingModal(true));
        handleCancel();
    };

    const handleStartTask = () => {
        // if job has flightBooking(arrivals) and doesn't have startTime it is a arrival task and needs to select passenger
        if ((job?.flightBooking || job?.combinedBooking || job?.combinedRampBooking) && !job?.startTime && !job?.stopped) {
            dispatch(setShowFlightList(true));
            handleCancel();
        } else {
            if (job && job?._id) {
                let tempJob = {
                    id: job._id,
                    active: true,
                    startTime: job?.startTime ? job.startTime : new Date(),
                    stopped: false,
                    paxPositionInfo: {
                        locationId: "Transit",
                        locationTitle: "null",
                        activity: "Picked up",
                        time: new Date()
                    },
                }
                dispatch(updateTask(tempJob));
                const currentStatus = job.isBreakTask ? "onBreak" : "busy"
                handleAgentStatus(currentStatus, job.uid ?? job.employeeId)
                let id = job?.originalBookingId ? job?.originalBookingId : job?._id;
                if (id && !id?.includes("-selfAllocatedTask-") && job?.buggyTask !== true && !id?.includes("-part") && !job?.flightBooking) {
                    const payload = {
                        taskId: id,
                        body: {
                            bookingsIds: [id],
                            taskType: "departure",
                            iata: dbUser.details.authority
                        }

                    };
                    dispatch(selectPassengers(payload));
                    // need to update booking object to add last drop off location
                    let object = {
                        bookingId: id,
                        location: 'Transit',
                        locationTitle: 'null',
                        activity: "Picked up",
                        time: new Date(),
                        checkInFlag: false
                    }
                    dispatch(setBookingLocation(object));
                }
            }
        };

        // toast message
        dispatch(setToast({
            message: "Task Started Successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    };
    //In case we should not send initial notification for create task during break, add condition selectedEmployee.onBreak
    const handleSendNotification = () => {
        const selectedEmployee = allEmployees?.find((employee) => employee?.employeeId == job?.employeeId)
        if (selectedEmployee && selectedEmployee.FCMTokens) {
            const notification = {
                notificationTitle: "New Assigned Task at " + job?.assignedTime,
                notificationText: `Please collect passenger ${job?.name ? job?.name : ""}`,
                fcmToken: selectedEmployee?.FCMTokens,
                iata: dbUser.details.authority
            };
            dispatch(sendEmployeeNotification(notification));

        }
    }


    const handleShowPaxList = () => {
        dispatch(setShowFlightList(true));
        handleCancel();
    };

    const handleCompleteTask = () => {
        if (job && job?._id) {
            let tempJob = {
                id: job._id,
                active: false,
                completed: true,
                completeTime: new Date(),
                paxPositionInfo: {
                    "activity": 'Dropped Off',
                    "locationId": "",
                    "locationName": "",
                    "time": new Date()
                }
            }
            dispatch(updateTask(tempJob));
            handleAgentStatus("online", job.uid ?? job.employeeId)

        }

        // toast message
        dispatch(setToast({
            message: "Task Completed Successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    };

    const handleStopTask = () => {
        if (job && job?._id) {
            let tempJob = {
                id: job._id,
                active: false,
                completed: false,
                stopped: true,
                stopTime: new Date(),
                cancelled: false,
            }
            dispatch(updateTask(tempJob));
            handleAgentStatus("online", job.uid ?? job.employeeId)

        }

        // toast message
        dispatch(setToast({
            message: "Task Stopped Successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    };

    const handleDuplicate = () => {
        let tempBooking = null
        if (job?.assignedTime) {
            if (job?.flightBooking) {
                const wantedBooking = arrivalsBooking.find(item => item?.doc?._id === job?.originalBookingId);
                if (wantedBooking) tempBooking = { ...wantedBooking?.doc }
            } else {
                const jobId = job._id?.split("_IATA")[0]
                if (!jobId) {
                    console.log("Cannot find job", job)
                    return;
                }
                const wantedBooking = departuresBooking.find(item => item?.doc?._id === jobId);
                if (wantedBooking) tempBooking = { ...wantedBooking?.doc }

            }
            let duplicateVersion = 1;           // initally, all duplicates are part-1

            if (tempBooking?.duplicateCount) {
                duplicateVersion = tempBooking?.duplicateCount + 1;
                dispatch(patchBooking({ ...tempBooking, duplicateCount: tempBooking?.duplicateCount + 1 }));
            } else {
                dispatch(patchBooking({ ...tempBooking, duplicateCount: 1 }));
            }
            setDuplicateCount(duplicateVersion);
        } else {
            // if job object has originalBookingDoc  and flightBooking it's an arrival flight
            if (job?.originalBookingDoc && job?.flightBooking) {
                tempBooking = { ...job?.originalBookingDoc }
            } else {
                tempBooking = { ...job }
            }

            if (tempBooking?.combinedBooking) {

                let originalCombinedBookingList = [...duplicatedCombinedBookings]

                let duplicateVersion = 1;           // initally, all duplicates are part-1

                // use duplicate list to count number of duplicates for this boarding pass
                if (duplicatedCombinedBookings && duplicatedCombinedBookings.length > 0) {
                    let tempDuplicates = duplicatedCombinedBookings.filter(item => item.doc._id.startsWith(tempBooking._id));
                    if (tempDuplicates && tempDuplicates.length > 0) {
                        duplicateVersion = tempDuplicates.length + 1;
                    }
                }

                tempBooking.duplicateVersion = duplicateVersion;

                let newId = tempBooking._id + "-part" + duplicateVersion;

                let newDuplicate = { doc: tempBooking, id: newId };
                newDuplicate.doc._id = newId;

                originalCombinedBookingList.push(newDuplicate);

                dispatch(setDuplicatedCombinedBookings(originalCombinedBookingList));
                handleCancel();

            } else if (tempBooking?.combinedRampBooking) {
                // check if duplicatedCombinedRampBookings is an array with length
                let originalCombinedRampBookingList = Array.isFullArray(duplicatedCombinedRampBookings) ? [...duplicatedCombinedRampBookings] : []

                let duplicateVersion = 1;           // initally, all duplicates are part-1

                // // use duplicate list to count number of duplicates for this boarding pass
                if (Array.isFullArray(originalCombinedRampBookingList)) {
                    let tempDuplicates = originalCombinedRampBookingList.filter(item => item.doc._id.startsWith(tempBooking._id));

                    if (Array.isFullArray(tempDuplicates)) {
                        duplicateVersion = tempDuplicates.length + 1;
                    }
                }

                tempBooking.duplicateVersion = duplicateVersion;

                let newId = tempBooking._id + "-part" + duplicateVersion;

                let newDuplicate = { doc: tempBooking, id: newId };
                newDuplicate.doc._id = newId;

                originalCombinedRampBookingList.push(newDuplicate);

                dispatch(setDuplicatedCombinedRampBookings(originalCombinedRampBookingList));
                handleCancel();
            }
            else {
                let duplicateVersion = 1;           // initally, all duplicates are part-1
                if (tempBooking?.duplicateCount) {
                    duplicateVersion = tempBooking?.duplicateCount + 1;
                    dispatch(patchBooking({ ...tempBooking, duplicateCount: tempBooking?.duplicateCount + 1 }));
                } else {
                    dispatch(patchBooking({ ...tempBooking, duplicateCount: 1 }));
                }
                setDuplicateCount(duplicateVersion);
            }

        }

        // toast message
        dispatch(setToast({
            message: "Task Duplicated Successfully",
            statusType: "success",
        }));
        dispatch(setShowToast(true));
    }



    //#endregion
    return (
        <div>
            <MenuList>
                {/*Start Task */}
                {canStartTask && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Start Task" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Start Task")} onMouseLeave={() => { setHover('none') }} color={hover == "Start Task" ? 'white' : 'gray'} onClick={handleStartTask}>
                        {(updateTaskStatus === "loading" && hover === "Start Task") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <FaCheck size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Start Task"}
                    </StyledParagraph>
                </div>}

                {/*Show Pax List */}
                {canShowPaxList && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Show Pax List" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Show Pax List")} onMouseLeave={() => { setHover('none') }} color={hover == "Show Pax List" ? 'white' : 'gray'} onClick={handleShowPaxList}>
                        {(updateTaskStatus === "loading" && hover === "Show Pax List") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <FaCheck size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Show Pax List"}
                    </StyledParagraph>
                </div>}

                {/*Complete Task */}
                {canCompleteTask && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Complete Task" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Complete Task")} onMouseLeave={() => { setHover('none') }} color={hover == "Complete Task" ? 'white' : 'gray'} onClick={handleCompleteTask}>
                        {(updateTaskStatus === "loading" && hover === "Complete Task") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <FaCheckDouble size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Complete Task"}
                    </StyledParagraph>
                </div>}

                {/* Stop Task */}
                {canStopTask && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Stop Task" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Stop Task")} onMouseLeave={() => { setHover('none') }} color={hover == "Stop Task" ? 'white' : 'gray'} onClick={handleStopTask}>
                        {(updateTaskStatus === "loading" && hover === "Stop Task") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <AiOutlineStop size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Stop Task"}
                    </StyledParagraph>
                </div>}
                {/*ReSend notification */}
                {canSendNotify && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Send Notification" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Send Notification")} onMouseLeave={() => { setHover('none') }} color={hover == "Send Notification" ? 'white' : 'gray'} onClick={handleSendNotification}>
                        {(sendNotificationStatus === "loading" && hover === "Send Notification") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <IoNotificationsOutline size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Send Notification"}
                    </StyledParagraph>
                </div>}


                {/*duplicate booking to assign to two employees */}
                {canDuplicate && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Duplicate" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Duplicate")} color={hover == "Duplicate" ? 'white' : 'gray'} onClick={handleDuplicate}>
                        {(postBookingStatus === "loading" || patchBookingStatus === "loading") ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <HiOutlineDuplicate size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Duplicate"}
                    </StyledParagraph>
                </div>}

                {/*pax check out */}
                {canCheckOut && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Check Out" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Check Out")} onMouseLeave={() => { setHover('none') }} color={hover == "Check Out" ? 'white' : 'gray'} onClick={handleCheckOut}>
                        {paxCheckOutStatus === "loading" ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <BiUserX size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"Check Out"}
                    </StyledParagraph>
                </div>}
                {/*pax check in */}
                {canCheckIn && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Check In" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Check In")} onMouseLeave={() => { setHover('none') }} color={hover == "Check In" ? 'white' : 'gray'} onClick={handleCheckIn}>
                        <BiUserCheck size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Check In"}
                    </StyledParagraph>
                </div>}
                {/*pax unReject */}
                {canUnReject && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "unReject" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("unReject")} onMouseLeave={() => { setHover('none') }} color={hover == "unReject" ? 'white' : 'gray'} onClick={handleUnRejectPax}>

                        {unRejectPaxStatus === "loading" ? <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} /> : <BiUserCheck size={20} style={{ marginInlineEnd: "5px" }} />}
                        {"unReject"}
                    </StyledParagraph>
                </div>}

                {/*QR code assign */}
                {canAssign && dbUser?.details?.authority != 'JER' && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Assign" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Assign")} onMouseLeave={() => { setHover('none') }} color={hover == "Assign" ? 'white' : 'gray'} onClick={handleScannerClick}>
                        <MdQrCode2 size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Assign"}
                    </StyledParagraph>
                </div>}
                {/* Unplan Task */}
                {canUnPlan && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Unplan" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Unplan")} onMouseLeave={() => { setHover('none') }} color={hover == "Unplan" ? 'white' : 'gray'} onClick={handleUnplanTask} style={{ flex: 1, display: 'flex' }}>
                        <div style={{ flex: 2 }}>
                            {deleteTaskStatus === "loading" ?
                                <CustomSpinner size="small" style={{ marginInlineEnd: "5px" }} />
                                :
                                <MdDeleteOutline size={20} style={{ marginInlineEnd: "5px" }} />
                            }
                        </div>
                        <div style={{ flex: 10 }}>
                            {"Unplan"}
                        </div>
                    </StyledParagraph>
                </div>}
                {/* Edit Task */}
                {canEdit && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Edit" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Edit")} onMouseLeave={() => { setHover('none') }} color={hover == "Edit" ? 'white' : 'gray'} onClick={handleEditTask}>
                        <CiEdit size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Edit"}
                    </StyledParagraph>
                </div>}

                {/*Delete Booking */}
                {canDeleteBooking && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === "Delete" ? Colors.PRM_LIGHT_BLUE : 'white', borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                    <StyledParagraph onMouseOver={() => setHover("Delete")} onMouseLeave={() => { setHover('none') }} color={hover == "Delete" ? 'white' : 'gray'} onClick={handleShowDeleteBookingModal}>
                        <MdDeleteOutline size={20} style={{ marginInlineEnd: "5px" }} />
                        {"Delete"}
                    </StyledParagraph>
                </div>}
                {/* View Task */}
                {canView && <div style={{ display: 'grid', placeItems: 'center', backgroundColor: hover === 'view' ? Colors.PRM_LIGHT_BLUE : 'white', borderBottomLeftRadius: 5, borderBottomRightRadius: 5, cursor: 'pointer' }}>
                    <StyledParagraph onMouseOver={() => setHover('view')} onMouseLeave={() => { setHover('none') }} color={hover == 'view' ? 'white' : 'grey'} onClick={handleViewTask}>
                        <IoEyeOutline size={20} style={{ marginInlineEnd: "5px" }} />
                        View
                    </StyledParagraph>
                </div>}

            </MenuList>
        </div>
    );
};

export default JobActionMenu;
